import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import LandingPage from './pages/landing-page';
import AdminDashboard from './pages/admin-dashboard';
import AdminLogin from './pages/admin-login';
import ClientLogin from './pages/client-login';
import ClientDashboard from './pages/client-dashboard';
import ClientRegistration from './pages/client-registration';
import ClientInventoryManagement from './pages/client-inventory-management';
import EditItemInformation from './pages/edit-item-information';
import AddInventoryItem from './pages/add-inventory-item';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Landing page as home */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/client-login" element={<ClientLogin />} />
        <Route path="/admin-dashboard" element={<AdminDashboard />} />
        <Route path="/client-dashboard" element={<ClientDashboard />} />
        <Route path="/client-registration" element={<ClientRegistration />} />
        <Route path="/client-inventory-management" element={<ClientInventoryManagement />} />
        <Route path="/edit-item-information" element={<EditItemInformation />} />
        <Route path="/edit-item-information/:itemId" element={<EditItemInformation />} />
        <Route path="/add-inventory-item" element={<AddInventoryItem />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;